import type { ComponentProps } from "react";

type Props = ComponentProps<"svg">;

const InfoIcon = (props: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
        fill="#000000"
      />
      <path
        d="M7.32727 11.8151H8.67114V6.9243H7.32727V11.8151ZM7.13086 5.05616C7.13086 5.52844 7.53402 5.92726 7.99921 5.92726C8.46439 5.92726 8.86755 5.52844 8.86755 5.05616C8.86755 4.59437 8.46439 4.18506 7.99921 4.18506C7.53402 4.18506 7.13086 4.59437 7.13086 5.05616Z"
        fill="#000000"
      />
    </svg>
  );
};

InfoIcon.displayName = "InfoIcon";

export default InfoIcon;
